exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".borders {\n    border-radius: 15px 90px 130px 5px;\n}\n\n.color-red {\n    background: #f44336;\n}\n\n.color-purple {\n    background: rgb(103, 58, 183);\n}\n\n.color-blue {\n    background: rgb(30, 136, 229);\n}\n\n.color-orange {\n    background: rgb(255, 152, 0);\n}\n\n.color-lightBlue {\n    background: rgb(0, 188, 212);\n}\n\n.color-green {\n    background: rgb(0, 150, 136);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// P:/Portfolio-angular-master/src/app/mid/end/end.component.css
// module id = ../../../../../src/app/mid/end/end.component.css
// module chunks = main